module.exports = __webpack_public_path__ + "static/media/netflixLogo.f31f3c82.png";